module.exports = __webpack_public_path__ + "img/all-hydro.d8594bc6.svg";